import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';
import gsap from 'gsap';

interface SolutionCardRefs {
  elementRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: SolutionCardRefs,
): void {
  timeline.fromTo(elementRef.current, {}, {});
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: SolutionCardRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}

export function scaleImage(
  imageRef?: RefObject<HTMLDivElement | null>,
  zoom = true,
  scaleValue = 1.1,
): void {
  if (imageRef?.current) {
    gsap.to(imageRef.current, {
      scale: zoom ? scaleValue : 1,
      ease: 'Quad.easeInOut',
      duration: 0.5,
    });
  }
}

export function onHover(
  backgroundHoverRef: RefObject<HTMLDivElement | null>,
  isHover: boolean,
): void {
  if (isHover) {
    gsap.fromTo(
      backgroundHoverRef.current,
      {
        yPercent: isHover ? 100 : 0,
      },
      {
        yPercent: 0,
        duration: 0.5,
        ease: 'Power2.easeOut',
      },
    );
  } else {
    gsap.to(backgroundHoverRef.current, {
      yPercent: -100,
      duration: 0.5,
      ease: 'Power2.easeOut',
    });
  }
}
